import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Render the app
const rootEl = document.getElementById("root");
if (rootEl) {
  const root = createRoot(rootEl);
  root.render(<App />);
  
  // Mark React as mounted - this hides the fallback immediately
  document.documentElement.classList.add("react-mounted");
}
